import { HTMLAttributes } from "react"
import { classNames } from "utils/ClassNames"

export type CardProps = HTMLAttributes<HTMLDivElement>

/** A bordered surface container with rounded corners. */
export const Card = ({ className, children, ...props }: CardProps) => (
  <div
    className={classNames(
      "rounded-md p-4 ring-1 ring-inset ring-gray-200 dark:ring-gray-700",
      className
    )}
    {...props}
  >
    {children}
  </div>
)
